<template>
    <div class="v-loading" v-show="loading">
      <Spin fix>
        <Icon type="ios-loading" :size="size" class="spin-icon-load"></Icon>
      </Spin>
    </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    loading: Boolean,
    size: {
      type: [String, Number],
      default: 40,
    },
  },
};
</script>

<style lang="less">
  .spin-icon-load{
    animation: v-loading-spin 1s linear infinite;
  }
  @keyframes v-loading-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
</style>
